export function StockBadge({ status, testId }) {
  const map = {
    "IN STOCK": "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
    "LOW STOCK": "bg-amber-500/15 text-amber-400 border-amber-500/40",
    "OUT OF STOCK": "bg-rose-500/15 text-rose-400 border-rose-500/40",
  };
  const dot = {
    "IN STOCK": "bg-emerald-400",
    "LOW STOCK": "bg-amber-400",
    "OUT OF STOCK": "bg-rose-400",
  };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold uppercase tracking-wider ${map[status] || map["OUT OF STOCK"]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot[status] || dot["OUT OF STOCK"]}`} />
      {status}
    </span>
  );
}
